const FieldType = {
	Double: 'Double',
	Dict: 'Dict',
};

export default FieldType;
